import { FilterAltIcon } from "@l2r-front/l2r-icons"
import { PropTypes } from "@l2r-front/l2r-proptypes"

import { FilterBottomSheet } from "../../components/FilterBottomSheet"

import * as Styled from "./FilterButton.styled"

export function FilterButton(props) {

    const {
        className,
        children,
        filterCount,
        onClick,
        onClose,
        open,
        ...otherProps
    } = props

    return <div className={className}>
        <Styled.Fab color="cta-bg/cta-bg-primary" id="mobile-filters-button" size="small" onClick={onClick}>
            <FilterAltIcon color="objects/object-lightgrey" />
            {filterCount ? <Styled.FilterCount id="filter-count">
                <Styled.Typography variant="Small">{filterCount}</Styled.Typography>
            </Styled.FilterCount> : null}
        </Styled.Fab>
        <FilterBottomSheet open={open} onClose={onClose} {...otherProps}>
            {children}
        </FilterBottomSheet>
    </div>
}

FilterButton.propTypes = {
    className: PropTypes.string,
    filterCount: PropTypes.number,
    open: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
}

FilterButton.defaultProps = {
    filterCount: 0,
}